import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface MetaItemProps {
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function MetaItem({ icon, children, className }: MetaItemProps) {
  return (
    <div
      className={cn(
        "mt-2 flex items-center text-xs text-text-muted",
        className
      )}
    >
      {icon}
      {children}
    </div>
  );
}
